'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const TeamLeaderboardInner = dynamic(() => import('./TeamLeaderboardInner'), { ssr: false });

export default function TeamLeaderboard() {
  return (
    <div className="card-surface p-5">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-foreground">Team Performance</h2>
        <p className="text-sm text-muted-foreground">Quota attainment — May 2026</p>
      </div>
      <TeamLeaderboardInner />
    </div>
  );
}